/**
 * @file Region Constants
 * @description Constants and selectors for region component
 */

// DOM Selectors - Optimized for performance
export const SELECTORS = {
  // Use IDs for unique elements (fastest)
  PROVINCE_LISTING: "#province-listing",
  REGION_BODY: "#region-body",
  VIETNAM_MAP: "#vietnam-map",
  LOADING_INDICATOR: "#loading-indicator",
  MAPS_WRAPPER: "#maps-wrapper",
  MAP_WRAPPER: "#map-wrapper",
  REGION_SELECT: "#region-select",
  TURN_BACK_BTN: "#turnBackBtn",
  OSM_WRAPPER: "#osm-wrapper",

  // Use specific classes for better performance
  MAIN_DESCRIPTION: ".main-des",
  REGION_DESCRIPTION: ".region-des",
  CHILD_MAPS: ".child-maps .map",
  REGION_ITEMS: ".mps-regions a",
  MAPSVG_REGIONS: ".mapsvg-region",
  VIETNAM_MAP_REGIONS: "#vietnam-map .mapsvg-region",
  CHILD_MAP_REGIONS: ".child-maps .mapsvg-region",
  VIEW_REGION_IPS: ".view-region-ips",
  BACK_BTN: ".back-btn",
  PROVINCE_MOBILE_NAV: "#province-mobile-nav-tab",

  // New optimized selectors
  REGION_ITEM_ACTIVE: ".mps-regions a.active",
  CHILD_MAP_ACTIVE: ".child-maps .map.active",
  PROVINCE_TAB: "#province-mobile-nav-tab .tab",
};

// Animation settings
export const ANIMATION = {
  HIDE_DELAY: 500,
  SHOW_DELAY: 500,
  TRANSITION_DURATION: "0.5s",
};

// Highlight styles
export const HIGHLIGHT = {
  MAP_FILTER: "brightness(1.2) drop-shadow(0 0 5px rgba(0,0,0,0.3))",
  ITEM_BACKGROUND: "#dbeafe",
  ITEM_COLOR: "#1e40af",
  ITEM_BORDER: "#1e40af",
};

// API Configuration
export const API_CONFIG = {
  BASE_URL: `${window.location.origin}/wp-json/wp/v2/industry_location`,
};

// Event Names
export const EVENTS = {
  REGION_CLICK: "region-click",
  REGION_MOUSEOVER: "region-mouseover",
  REGION_MOUSELEAVE: "region-mouseleave",
  BACK_BUTTON_CLICK: "back-button-click",
  PROVINCE_TAB_CLICK: "province-tab-click",
};
